import { render, staticRenderFns } from "./AddTable.vue?vue&type=template&id=37e59a93&scoped=true&"
import script from "./AddTable.vue?vue&type=script&lang=js&"
export * from "./AddTable.vue?vue&type=script&lang=js&"
import style0 from "./AddTable.vue?vue&type=style&index=0&id=37e59a93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e59a93",
  null
  
)

export default component.exports